// PURPOSE: makes sure that salesOrder numbers are always printed out with 5 digits

export function displaySalesOrderNumber(salesOrderNumber) {
  let finalsalesOrderNumber = "";
  if (salesOrderNumber < 10) {
    finalsalesOrderNumber = `0000${salesOrderNumber}`
    return finalsalesOrderNumber
  } else if ( salesOrderNumber < 100) {
    finalsalesOrderNumber = `000${salesOrderNumber}`
    return finalsalesOrderNumber
  } else if ( salesOrderNumber < 1000) {
    finalsalesOrderNumber = `00${salesOrderNumber}`
    return finalsalesOrderNumber
  } else if ( salesOrderNumber < 10000) {
    finalsalesOrderNumber = `0${salesOrderNumber}`
    return finalsalesOrderNumber
  }

  finalsalesOrderNumber = `${salesOrderNumber}`
  return finalsalesOrderNumber
}
